import { checkHEIC } from '@/helpers/checkHEIC'

export const compressImage = async (params: {
  imageFile: File
  maxSize?: number
  threshold?: number
}) => {
  const { imageFile, maxSize = 7500, threshold = 9999 } = params

  return new Promise<File>((resolve, reject) => {
    if (checkHEIC(imageFile)) {
      resolve(imageFile)
      return
    }

    if (!imageFile.type.startsWith('image/')) {
      reject(new Error('Переданный файл не является изображением'))
      return
    }

    const img = new Image()
    const url = URL.createObjectURL(imageFile)

    img.onload = () => {
      URL.revokeObjectURL(url)

      const originalWidth = img.width
      const originalHeight = img.height

      if (originalWidth <= threshold && originalHeight <= threshold) {
        resolve(imageFile)
        return
      }

      let newWidth = maxSize
      let newHeight = maxSize

      if (originalWidth > originalHeight) {
        newHeight = Math.ceil((originalHeight * maxSize) / originalWidth)
      } else {
        newWidth = Math.ceil((originalWidth * maxSize) / originalHeight)
      }

      const canvas = document.createElement('canvas')

      canvas.width = newWidth
      canvas.height = newHeight

      const ctx = canvas.getContext('2d')

      if (!ctx) {
        return imageFile
      }

      ctx.imageSmoothingEnabled = true
      ctx.imageSmoothingQuality = 'high'

      ctx.drawImage(img, 0, 0, newWidth, newHeight)

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            resolve(imageFile)

            return
          }

          const compressedFile = new File([blob], imageFile.name, {
            type: imageFile.type,
            lastModified: new Date().getTime(),
          })

          resolve(compressedFile)
        },
        imageFile.type,
        0.9
      )
    }

    img.onerror = () => {
      URL.revokeObjectURL(url)
      reject(new Error('Не удалось загрузить изображение'))
    }

    img.src = url
  })
}
